module.exports = __webpack_public_path__ + "static/media/img-photo_activo.021e264b.svg";